/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureSubscribeFormModel(data) {
  return {
    user_notice_types_category_id: lc.get(
      data,
      'subscribe.user_notice_types_category_id'
    ),
    app_notice: lc.get(data, 'subscribe.app_notice'),
    email_notice: lc.get(data, 'subscribe.email_notice'),
    telegram_notice: lc.get(data, 'subscribe.telegram_notice')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/services/EventsUserNoticeSubscribeService/restructuring/index.js